// utils/creditUtils.ts
export const CREDIT_KEY = "userCredit";
export const DEFAULT_CREDITS = 35; // 用户每日积分上限
export const CREDITS_PER_IMAGE = 30; // 每张图像扣除的学分

export interface ICreditLimit {
  daily_limit: number;
  used_today: number;
}

export interface ICreditLimit {
  daily_limit: number;
  used_today: number;
}

export interface UserCredit {
  credits: number;
  lastResetDate: string; // ISO date string
  nickname: string; // 用户昵称
  token: string; // 认证令牌，空字符串表示未登录
  role: string;
  daily_limit: number;
  used_today: number;
  isNeedToShowWelcomePopop?: boolean;
  user_id: number;
  email: string;
}

// 初始化或获取用户积分信息
export const getUserCredit = (): UserCredit => {
  const stored = localStorage.getItem(CREDIT_KEY);
  if (stored) {
    return JSON.parse(stored);
  }
  // 首次访问的默认值
  const today = new Date().toISOString().split("T")[0];

  const initialCredit: UserCredit = {
    credits: DEFAULT_CREDITS, // 使用常量
    lastResetDate: today,
    nickname: "",
    token: "",
    role: "admin",
    daily_limit: 0,
    used_today: 0,
    user_id: 0,
    email: "",
  };

  // 存储初始值到 localStorage
  saveUserCredit(initialCredit);
  return initialCredit;
};

// 移除缓存
export const removeUserCredit = () => {
  localStorage.removeItem(CREDIT_KEY);
  localStorage.removeItem("userInfo");
};

// 设置新的缓存
export const saveUserCredit = (credit: UserCredit) => {
  localStorage.setItem(CREDIT_KEY, JSON.stringify(credit));
};

// 计算距离下次午夜12点的时间
export const getMsUntilMidnight = () => {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  return midnight.getTime() - now.getTime();
};

// 只为未登录用户重置积分
export const resetGuestCredits = () => {
  const currentCredit = getUserCredit();
  const today = new Date().toISOString().split("T")[0];

  // 仅对未登录用户（token 为空）重置积分
  if (currentCredit.token === "" && currentCredit.lastResetDate !== today) {
    currentCredit.credits = DEFAULT_CREDITS; // 使用常量
    currentCredit.lastResetDate = today;
    saveUserCredit(currentCredit);
  }
  // 已登录用户保持原有积分，不更新 lastResetDate
};
